import { z } from "zod";

export const DEMO_ARCHETYPE_KEYS = [
  "startupVc",
  "academicAlumni",
  "industryCorporate",
  "intimateCommunity",
] as const;

// Mirrors the backend `PERSONAS_PER_ARCHETYPE`; kept frontend-local (no shared
// move) and single-sourced so seed form components don't re-hardcode the bound.
export const MAX_PERSONAS_PER_ARCHETYPE = 12;

const countField = z
  .number()
  .int()
  .min(0)
  .max(MAX_PERSONAS_PER_ARCHETYPE)
  .optional();

export const DemoPersonaSeedCountsSchema = z.object({
  startupVc: countField,
  academicAlumni: countField,
  industryCorporate: countField,
  intimateCommunity: countField,
});

export type DemoPersonaSeedCounts = z.infer<typeof DemoPersonaSeedCountsSchema>;

export const SeedDemoParticipantsResponseSchema = z.object({
  participantsAdded: z.number(),
  enrichmentRecordsCreated: z.number(),
  pickStepResultsCreated: z.number(),
});

export type SeedDemoParticipantsResponse = z.infer<
  typeof SeedDemoParticipantsResponseSchema
>;
